import React from "react";
import styles from "@/styles/BreadCrumb.module.scss";
import { PEILink } from "@/common";
import { URL } from "@/utils";

const { basePEIURL, brand } = URL;

type props = {
  title?: string;
};

export const BreadCrumb = ({ title }: props) => {
  return (
    <nav
      className={styles.container}
      id='bread-crumb'
    >
     {brand === 'pei' && <ul className={styles["breadcrumb-list"]}>
        <li className={styles["breadcrumb-list-item"]}>
          <PEILink
            href={`${basePEIURL}/company-profiles`}
            className={styles["breadcrumb-list-item-link"]}
          >
            All Profiles
          </PEILink>

          <span className={styles["breadcrumb-list-item-gt-icon"]}>&gt;</span>
        </li>
        <li className={styles["breadcrumb-list-item"]}>
          <span className={styles["breadcrumb-list-item-link"]}>{title}</span>
        </li>
      </ul>}
    </nav>
  );
};
